module.exports = __webpack_public_path__ + "assets/images/14-5.jpg";